import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import Image from 'components/ui/Image/Image'
import Modal from 'components/modal/Modal/Modal'
import ModalFooter from 'components/modal/ModalFooter/ModalFooter'
import UpchargePrice from 'components/UpchargePrice/UpchargePrice'
import CommonButton from 'components/buttons/CommonButton/CommonButton'

import messages from './messages'
import s from './WelcomeBackModal.scss'


class WelcomeBackModal extends PureComponent {

  static propTypes = {
    data: PropTypes.shape({
      item: PropTypes.shape({
        image: PropTypes.string.isRequired,
        upchargePrice: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  }

  static defaultProps = {
    name: constants.modals.premiumProducts.WelcomeBack,
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, data: { item: { image, upchargePrice = 1000 } = {} } } = this.props

    return (
      <Modal
        name={name}
        title={messages.title}
        titleUppercase
      >
        <FormattedMessage className={s.subTitle} tag="div" {...messages.subTitle} />
        <FormattedMessage className={s.text} tag="div" {...messages.text} />
        <div className={s.imageContainer}>
          <UpchargePrice className={s.priceLabel} price={upchargePrice} large />
          <Image className={s.image} src={image} h={300} mH={200} alt="Scentbird" />
        </div>
        <FormattedMessage className={s.hint} tag="div" {...messages.hint} />
        <ModalFooter>
          <CommonButton className={s.button} brand lg gotIt onClick={this.close} />
        </ModalFooter>
      </Modal>
    )
  }
}


export default WelcomeBackModal
